module.exports = {
          srcSet: __webpack_public_path__ + "911220490038046fc6f12e93a6376d55-96.png"+" 96w",
          images:[ {path: __webpack_public_path__ + "911220490038046fc6f12e93a6376d55-96.png",width: 96,height: 915}],
          src: __webpack_public_path__ + "911220490038046fc6f12e93a6376d55-96.png",
          toString:function(){return __webpack_public_path__ + "911220490038046fc6f12e93a6376d55-96.png"},
          
          width: 96,
          height: 915
        }